import { render } from "./LeadsPage.vue?vue&type=template&id=793daaf0"
import script from "./LeadsPage.vue?vue&type=script&lang=js"
export * from "./LeadsPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__